<template>
  <div class="finish-repair-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('finishRepair.title')" :subtitle="$t('finishRepair.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-back" @click="backToList">
          {{ $t('common.back') }}
        </el-button>
        <el-button type="primary" icon="el-icon-check" @click="submitFinishRepair">
          {{ $t('common.submit') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- 表单面板 -->
    <div class="ds-panel">
      <el-form label-width="150px" label-position="right" class="ds-form">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('finishRepair.materialUsage')"
              v-if="finishRepairInfo.repairObjType != '004'">
              <el-select v-model="finishRepairInfo.maintenanceType" class="w-full"
                :placeholder="$t('finishRepair.selectMaterialUsage')">
                <template v-for="(item, index) in finishRepairInfo.maintenanceTypes">
                  <el-option :key="index" :label="item.name" :value="item.statusCd"
                    v-if="item.statusCd != '1001' && item.statusCd != '1002'">
                  </el-option>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('finishRepair.repairType')" v-if="finishRepairInfo.repairObjType == '004'">
              <el-select v-model="finishRepairInfo.maintenanceType" class="w-full"
                :placeholder="$t('finishRepair.selectRepairType')">
                <template v-for="(item, index) in finishRepairInfo.maintenanceTypes">
                  <el-option :key="index" :label="item.name" :value="item.statusCd"
                    v-if="item.statusCd != '1003' && item.statusCd != '1004'">
                  </el-option>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item :label="$t('finishRepair.selectGoods')"
              v-if="finishRepairInfo.maintenanceType == '1001' || finishRepairInfo.maintenanceType == '1003'">
              <el-button type="primary" icon="el-icon-plus" @click="openChooseSingleResourceModel">
                {{ $t('finishRepair.selectGoods') }}
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 已选商品列表 -->
        <el-row :gutter="16"
          v-if="(finishRepairInfo.maintenanceType == '1001' || finishRepairInfo.maintenanceType == '1003') && finishRepairInfo.choosedGoodsList.length > 0">
          <el-col :span="24">
            <div class="ds-sub-panel">
              <div class="ds-sub-panel__title">{{ $t('finishRepair.usedGoods') }}</div>
              <ds-data-table :data="finishRepairInfo.choosedGoodsList" border>
                <el-table-column prop="rstName" :label="$t('finishRepair.category')"></el-table-column>
                <el-table-column prop="resName" :label="$t('finishRepair.goods')"></el-table-column>
                <el-table-column prop="price" :label="$t('finishRepair.price')"
                  v-if="finishRepairInfo.maintenanceType == '1001'">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.price"
                      :disabled="!scope.row.isCustom && scope.row.outHighPrice == scope.row.outLowPrice"
                      @change="updateTotalPrice" :min="scope.row.outLowPrice" :max="scope.row.outHighPrice">
                    </el-input-number>
                    <span v-if="!scope.row.isCustom && scope.row.outHighPrice != scope.row.outLowPrice">
                      ({{ scope.row.outLowPrice }} - {{ scope.row.outHighPrice }})
                    </span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('finishRepair.quantity')">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.useNumber" @change="updateTotalPrice" :min="1">
                    </el-input-number>
                  </template>
                </el-table-column>
                <el-table-column prop="miniUnitCodeName" :label="$t('finishRepair.unit')" width="80"></el-table-column>
                <el-table-column prop="specName" :label="$t('finishRepair.spec')" width="80"></el-table-column>
                <el-table-column :label="$t('finishRepair.operation')" width="120">
                  <template slot-scope="scope">
                    <el-button type="danger" size="mini" @click="removeChoosedGoodsItem(scope.$index)">
                      <i class="el-icon-delete"></i>{{ $t('common.remove') }}
                    </el-button>
                  </template>
                </el-table-column>
              </ds-data-table>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('finishRepair.totalAmount')" v-if="finishRepairInfo.maintenanceType == '1001'">
              <el-input v-model="finishRepairInfo.totalPrice" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('finishRepair.paymentMethod')" v-if="finishRepairInfo.maintenanceType == '1001'">
              <el-select v-model="finishRepairInfo.payType" class="w-full"
                :placeholder="$t('finishRepair.selectPaymentMethod')">
                <el-option v-for="(item, index) in finishRepairInfo.payTypes" :key="index" :label="item.name"
                  :value="item.statusCd">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item :label="$t('finishRepair.suggestion')">
              <el-input type="textarea" :rows="4" :placeholder="$t('finishRepair.inputSuggestion')"
                v-model="finishRepairInfo.context">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('finishRepair.beforeRepairPhoto')">
              <upload-image-url ref="beforeRepairUpload" @notifyUploadCoverImage="handleBeforeRepairImage">
              </upload-image-url>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('finishRepair.afterRepairPhoto')">
              <upload-image-url ref="afterRepairUpload" @notifyUploadCoverImage="handleAfterRepairImage">
              </upload-image-url>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 表单操作区 -->
        <div class="ds-form-actions">
          <el-button icon="el-icon-close" @click="backToList">
            {{ $t('common.back') }}
          </el-button>
          <el-button type="primary" icon="el-icon-check" @click="submitFinishRepair">
            {{ $t('common.submit') }}
          </el-button>
        </div>
      </el-form>
    </div>

    <choose-single-resource ref="chooseSingleResource" @choose-single-resource="chooseSingleResource"></choose-single-resource>
  </div>
</template>

<script>
import { getDict } from '@/api/community/communityApi'
import { getCommunityId } from '@/api/community/communityApi'
import { repairFinish } from '@/api/work/finishRepairApi'
import { getUserName } from '@/api/user/userApi'
import UploadImageUrl from '@/components/upload/UploadImageUrl'
import ChooseSingleResource from '@/components/work/chooseSingleResource'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'

export default {
  name: 'FinishRepairList',
  components: {
    UploadImageUrl,
    ChooseSingleResource,
    DsPageHeader,
    DsDataTable
  },
  data() {
    return {
      finishRepairInfo: {
        repairId: '',
        repairType: '',
        context: '',
        feeFlag: '200',
        repairObjType: '',
        publicArea: '',
        repairChannel: '',
        maintenanceTypes: [],
        maintenanceType: '',
        totalPrice: 0,
        choosedGoodsList: [],
        beforeRepairPhotos: [],
        afterRepairPhotos: [],
        payTypes: [],
        payType: ''
      },
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.initData()
  },
  methods: {
    chooseSingleResource(goods) {
      this.finishRepairInfo.choosedGoodsList.push(goods)
      this.updateTotalPrice()
    },
    async initData() {
      this.finishRepairInfo.repairType = this.$route.query.repairType
      this.finishRepairInfo.repairId = this.$route.query.repairId
      this.finishRepairInfo.repairObjType = this.$route.query.repairObjType
      this.finishRepairInfo.publicArea = this.$route.query.publicArea
      this.finishRepairInfo.repairChannel = this.$route.query.repairChannel

      try {
        const maintenanceTypes = await getDict('r_repair_pool', 'maintenance_type')
        this.finishRepairInfo.maintenanceTypes = maintenanceTypes

        const payTypes = await getDict('r_repair_pool', 'pay_type')
        this.finishRepairInfo.payTypes = payTypes
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    openChooseSingleResourceModel() {
      this.$refs.chooseSingleResource.open({
        maintenanceType: this.finishRepairInfo.maintenanceType
      })
    },
    handleBeforeRepairImage(photos) {
      this.finishRepairInfo.beforeRepairPhotos = photos.map(item => ({
        photo: item
      }))
    },
    handleAfterRepairImage(photos) {
      this.finishRepairInfo.afterRepairPhotos = photos.map(item => ({
        photo: item
      }))
    },
    removeChoosedGoodsItem(index) {
      this.finishRepairInfo.choosedGoodsList.splice(index, 1)
      this.updateTotalPrice()
    },
    updateTotalPrice() {
      let totalPrice = 0
      this.finishRepairInfo.choosedGoodsList.forEach(item => {
        totalPrice += item.price * item.useNumber
      })
      this.finishRepairInfo.totalPrice = totalPrice.toFixed(2)
    },
    validateForm() {
      if (!this.finishRepairInfo.repairId) {
        this.$message.error(this.$t('finishRepair.validate.repairIdRequired'))
        return false
      }
      if (!this.finishRepairInfo.maintenanceType) {
        this.$message.error(this.$t('finishRepair.validate.maintenanceTypeRequired'))
        return false
      }
      if (!this.finishRepairInfo.context) {
        this.$message.error(this.$t('finishRepair.validate.contextRequired'))
        return false
      }
      if (this.finishRepairInfo.beforeRepairPhotos.length === 0) {
        this.$message.error(this.$t('finishRepair.validate.beforePhotoRequired'))
        return false
      }
      if (this.finishRepairInfo.afterRepairPhotos.length === 0) {
        this.$message.error(this.$t('finishRepair.validate.afterPhotoRequired'))
        return false
      }
      if ((this.finishRepairInfo.maintenanceType === '1001' || this.finishRepairInfo.maintenanceType === '1003') &&
        this.finishRepairInfo.choosedGoodsList.length === 0) {
        this.$message.error(this.$t('finishRepair.validate.goodsRequired'))
        return false
      }
      if (this.finishRepairInfo.maintenanceType === '1001' && !this.finishRepairInfo.payType) {
        this.$message.error(this.$t('finishRepair.validate.paymentMethodRequired'))
        return false
      }
      return true
    },
    async submitFinishRepair() {
      if (!this.validateForm()) return

      try {
        const params = {
          ...this.finishRepairInfo,
          communityId: this.communityId,
          userName: getUserName()
        }
        const res = await repairFinish(params)
        if (res.code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this.backToList()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error(this.$t('finishRepair.submitError'))
      }
    },
    backToList() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.finish-repair-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  padding: var(--ds-spacing-lg);
}

/* 表单 */
.ds-form {
  .el-form-item {
    margin-bottom: var(--ds-spacing-lg);
  }
}

/* 子面板 */
.ds-sub-panel {
  margin-bottom: var(--ds-spacing-lg);

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
    margin-bottom: var(--ds-spacing-sm);
  }
}

/* 表单操作区 */
.ds-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-spacing-sm);
  padding-top: var(--ds-spacing-md);
  border-top: 1px solid var(--ds-gray-200);
}
</style>
